export const wordsAnnotations = [
  {
    count: 11,
    label: '🪄 Abracadabra',
    term: 'abracadabra',
  },
  {
    count: 13,
    label: '☄️ Marijuana',
    term: 'marijuana'
  },
  {
    count: 15,
    label: '💶 Soldo',
    term: 'soldo',
  },
  {
    count: 18,
    image: '/assets/img/icon-ghali.png',
    label: 'Ghali',
    term: 'ghali',
  },
  {
    count: 34,
    label: '🚬 Fumo',
    term: 'fumo'
  },
  {
    count: 45,
    label: '🤰 Mamma',
    term: 'mamma',
  },
  {
    count: 128,
    label: 'Stare',
    term: 'stare',
  }
];

export const verbsAnnotations = [
  {
    count: 53,
    label: 'Volere',
    term: 'volere',
  },
  {
    count: 18,
    label: '🚬 Fumare',
    term: 'fumare'
  },
  {
    count: 11,
    label: 'Pregare',
    term: 'pregare',
  },
  {
    count: 60,
    label: 'Sapere',
    term: 'sapere',
  },
  {
    count: 204,
    label: 'Avere',
    term: 'avere',
  },
  {
    count: 448,
    label: 'Essere',
    term: 'essere',
  },
];